import * as yup from "yup"
import type { Output } from "../../types"

export function initialValuesOutput(output?: Output | undefined) {
  if (output) {
    return output
  }
  return {
    title: "",
    description_short: "",
    type: "",
    description: "",
    date: "",
    image: "",
    attachment_file: "",
    link: "",
    order: 0,
  }
}

export function validationSchemaOutput() {
  return yup.object().shape({
    title: yup.string().required("Campo obbligatorio"),
    description_short: yup.string().required("Campo obbligatorio"),
    type: yup.string().required("Campo obbligatorio"),
  })
}
